import { PERMANENT_ACTIVE_LISTS } from '../../../connect/state/activeLists'
import { AlertsConfig } from '../../../types'
import { listAction, userAction } from '../../actions/workerActions'
import { ListAction, ListType, UserAction } from '../../constants/enums'
import { mfcAccountsUIDtoSlug } from '../../constants/mfcAccounts'

const ALWAYS_SUBSCRIBED_LISTS = {
    ...PERMANENT_ACTIVE_LISTS,
}
const ALWAYS_SUBSCRIBED_USERS = {
    ...mfcAccountsUIDtoSlug,
}

export const SUBSCRIBED_TO_WORKER_LIST: Partial<Record<ListType, number>> = {}
export const SUBSCRIBED_TO_WORKER_USER: Record<number, number> = {}

//
// LISTS
//
export function subscribeWorkerListUpdates(key: ListType) {
    if (!key) return
    if (typeof SUBSCRIBED_TO_WORKER_LIST[key] !== 'number') {
        SUBSCRIBED_TO_WORKER_LIST[key] = 0
    }
    SUBSCRIBED_TO_WORKER_LIST[key]++
    if (SUBSCRIBED_TO_WORKER_LIST[key] > 1) {
        // already subscribed to updates
        return
    }
    // send message to worker to start sending updates
    listAction(ListAction.SUBSCRIBE_UPDATES, { key })
}

export function unsubscribeWorkerListUpdates(key: ListType) {
    if (!key) return
    if (!SUBSCRIBED_TO_WORKER_LIST[key]) {
        // not subscribed
        return
    }
    SUBSCRIBED_TO_WORKER_LIST[key]--
    if (SUBSCRIBED_TO_WORKER_LIST[key] > 0) {
        // still need to be subscribed to updates
        return
    }
    if (ALWAYS_SUBSCRIBED_LISTS[key]) {
        // don't unsubscribe if it's a permanent list
        return
    }
    // send message to worker to stop sending updates
    listAction(ListAction.UNSUBSCRIBE_UPDATES, { key })
}

//
// USERS
//
export function subscribeWorkerUserUpdates(id: number) {
    if (!id) return
    if (typeof SUBSCRIBED_TO_WORKER_USER[id] !== 'number') {
        SUBSCRIBED_TO_WORKER_USER[id] = 0
    }
    SUBSCRIBED_TO_WORKER_USER[id]++
    if (SUBSCRIBED_TO_WORKER_USER[id] > 1) {
        // already subscribed to updates
        return
    }
    // send message to worker to start sending updates
    userAction(UserAction.SUBSCRIBE_UPDATES, { id })
}

export function unsubscribeWorkerUserUpdates(id: number) {
    if (!id) return
    if (!SUBSCRIBED_TO_WORKER_USER[id]) {
        // not subscribed
        return
    }
    SUBSCRIBED_TO_WORKER_USER[id]--
    if (SUBSCRIBED_TO_WORKER_USER[id] > 0) {
        // still need to be subscribed to updates
        return
    }
    if (ALWAYS_SUBSCRIBED_USERS[id]) {
        // don't unsubscribe!
        return
    }
    // send message to worker to stop sending updates
    userAction(UserAction.UNSUBSCRIBE_UPDATES, { id })
}

export function subscribeWorkerAlertsUpdates(config: AlertsConfig) {
    if (!config) return

    // Send message to worker to start sending updates
    userAction(UserAction.SUBSCRIBE_ALERTS, config)
}

export function unsubscribeWorkerAlertsUpdates(config: AlertsConfig) {
    if (!config) return

    // Send message to worker to stop sending updates
    userAction(UserAction.UNSUBSCRIBE_ALERTS, config)
}
